var _a;
import { optionsMap } from 'pro-gallery-lib';
export var VIDEO = {
    VOLUME: 'controllers_optionsMap_behaviourParams_item_video_volume',
};
export var VIDEO_CONTROLLERS = (_a = {},
    _a[VIDEO.VOLUME] = function (value) {
        var _a;
        return _a = {},
            _a[optionsMap.behaviourParams.item.video.volume] = value ? 1 : 0,
            _a;
    },
    _a);
//# sourceMappingURL=video.js.map